import { createContext, memo, useMemo, useState } from 'react';
import {
  DialogBody,
  DialogCloseTrigger,
  DialogContent,
  DialogHeader,
  DialogRoot,
} from '@/components';
import { getStaticFile } from '@/utils';

interface IState {
  showModal: boolean;
  image?: string;
}

interface IImagePreviewContext {
  toggleImagePreview: (image?: string) => void;
}

const ImagePreviewContext = createContext<IImagePreviewContext>({
  toggleImagePreview: () => {},
});

const initState: IState = {
  showModal: false,
};

function Component({ children }: any) {
  const [state, setState] = useState<IState>(initState);

  const contextValue = useMemo(
    () => ({
      toggleImagePreview: (image?: string) => {
        if (!image) return;
        const imageUrl = getStaticFile(image);
        setState(() => ({ ...state, showModal: true, image: imageUrl }));
      },
    }),
    []
  );

  const handleCancel = () => {
    setState(initState);
  };

  return (
    <ImagePreviewContext.Provider value={contextValue}>
      <DialogRoot open={state.showModal} motionPreset="slide-in-right">
        {/* @ts-ignore */}
        <DialogContent className="modal-image-preview" onClick={handleCancel}>
          <DialogHeader></DialogHeader>

          <DialogBody>
            <img src={state.image} alt="" />
          </DialogBody>

          {/* @ts-ignore */}
          <DialogCloseTrigger onClick={handleCancel} />
        </DialogContent>
      </DialogRoot>
      {children}
    </ImagePreviewContext.Provider>
  );
}

const ImagePreviewProvider = memo(Component);
export { ImagePreviewContext, ImagePreviewProvider };
